import { CheckBox } from '@jfs/ui-new'

interface CompoundCheckboxInterface {
  isChecked?: boolean
  onCheckboxPress?: (isChecked: boolean) => void
  isEdit?: boolean
}

export const CompoundCheckbox = ({ isChecked, onCheckboxPress, isEdit }: CompoundCheckboxInterface) => {
  // console.log('isChecked', isChecked)

  // const [checked, toggleChecked] = useState(isChecked ?? false)

  const onPress = (checked: string) => {
    // const newState = !checked
    // toggleChecked(newState)
    onCheckboxPress && onCheckboxPress(checked === 'true')
  }

  return (
    <CheckBox
      checked={isChecked}
      iconSize={18}
      color={isChecked && isEdit ? 'BLUE_SHADE' : 'GREY_MATTE'}
      onChange={isEdit ? onPress : undefined}
      textColor={'BLACK_75'}
      fontSize={13}
      fontWeight={'BOLD'}
    />
  )
}
